import { adminApi } from "./admin.api.js";

/**
 * Dashboard stat cards. Each backend list endpoint returns paginated meta
 * with `total`, so we issue limit=1 queries to read the count without
 * shipping the full result set.
 */
export async function fetchDashboardStats() {
  // 30-day window for the form-submissions stat (Tech Impl § 9.2).
  const thirtyDaysAgo = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString();

  // Run every count in parallel — the dashboard renders quickly even on a
  // cold MongoDB connection because each query is index-only.
  const [designs, publishedDesigns, blogs, scheduledBlogs, recentForms, totalForms, matterport] =
    await Promise.all([
      adminApi.list("designs", { limit: 1 }),
      adminApi.list("designs", { limit: 1, status: "published" }),
      adminApi.list("blogs", { limit: 1 }),
      adminApi.list("blogs", { limit: 1, status: "scheduled" }),
      adminApi.list("forms", { limit: 1, fromDate: thirtyDaysAgo }),
      adminApi.list("forms", { limit: 1 }),
      adminApi.list("matterport", { limit: 1 }),
    ]);

  return {
    designs: { total: designs.meta.total, published: publishedDesigns.meta.total },
    blogs: { total: blogs.meta.total, scheduled: scheduledBlogs.meta.total },
    forms: { last30Days: recentForms.meta.total, total: totalForms.meta.total },
    matterport: { total: matterport.meta.total },
  };
}

export async function fetchRecentForms(limit = 5) {
  const { items } = await adminApi.list("forms", { limit, sort: "createdAt:desc" });
  return items;
}

export async function fetchRecentActivity(limit = 8) {
  const { items } = await adminApi.list("activity-logs", { limit });
  return items;
}
